"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Scrollable: {
    displayName: "Scrollable"
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: "/home/Devel/web/productionRc/Agama2016/src/components/Scrollable/Scrollable.js",
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import GeminiScrollbar from 'react-gemini-scrollbar';

// import styles from '../../../node_modules/react-gemini-scrollbar/node_modules/gemini-scrollbar/gemini-scrollbar.css';
// require("style!css!./file.css").
// import '../../../node_modules/gemini-scrollbar/gemini-scrollbar.css';
// require('style!css!../../../node_modules/gemini-scrollbar/gemini-scrollbar.css');


var Scrollable = _wrapComponent("Scrollable")((_temp = _class = function (_Component) {
  (0, _inherits3.default)(Scrollable, _Component);

  function Scrollable() {
    (0, _classCallCheck3.default)(this, Scrollable);
    return (0, _possibleConstructorReturn3.default)(this, (Scrollable.__proto__ || (0, _getPrototypeOf2.default)(Scrollable)).apply(this, arguments));
  }

  (0, _createClass3.default)(Scrollable, [{
    key: "render",


    // componentDidMount() {
    //   const elem = this.refs.elem1;

    //   const onResize = ()=> {
    //     if (!elem) return;
    //     const height = elem.parentNode.offsetHeight;
    //    // alert(height);
    //     elem.style.height = (height - 50) + 'px';
    //   };
    //   // window.addEventListener('resize', onResize);
    //   // window.setTimeout(onResize, 1000);
    //   // window.setTimeout(onResize, 2000);
    //   // window.setTimeout(onResize, 3000);
    //   // window.setTimeout(onResize, 5000);
    //   window.setInterval(onResize, 30000);
    //   // window.setTimeout(onResize, 20000);


    // }

    // componentWillUnmount() {
    //   window.removeEventListener('resize', this.onResize);
    // }

    // The suggestion from Marco Aurélio is actually the best solution.
    // It works best if you set overflow-y: scroll
    // AND adding -webkit-overflow-scrolling: touch to the element as well. You'll get a native-like scroll feeling

    // TODO: měnit styl v závisloti na  body.resize

    value: function render() {
      return _react3.default.createElement(
        "div",
        { className: "scrollable" },
        this.props.children
      );
    }

    // TODO: gemini scrollbar nezvládá dynamickou výšku 100%, udělat nejak výpočtem
    // see http://stackoverflow.com/questions/19014250/reactjs-rerender-on-browser-resize

    // render() {
    //   const styles = require('./Scrollable.less');
    //   const style = {height: '300px', width: '100%' };
    //   return (
    //      <div style={style} ref="elem1">
    //     <GeminiScrollbar className={styles.agScrollable} >
    //       {this.props.children}
    //     </GeminiScrollbar>
    //      </div>

    //   );
    // }

  }]);
  return Scrollable;
}(_react2.Component), _class.propTypes = {
  children: _react2.PropTypes.oneOfType([_react2.PropTypes.arrayOf(_react3.default.PropTypes.node), _react2.PropTypes.node])
}, _temp));

exports.default = Scrollable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Scrollable/Scrollable.js
// module id = 1190
// module chunks = 0